import { START_INTRO_TOUR, RESET_INTRO_TOUR } from 'constants/ActionTypes';

export const startIntroTour = page => {
	return {
		type: START_INTRO_TOUR,
		payload: { page }
	};
};

export const resetIntroTour = () => {
	return {
		type: RESET_INTRO_TOUR
	};
};



// WEBPACK FOOTER //
// ./actions/Intro.js